import { ConfigProvider, Form, TimePicker } from "antd";
import localeEn from "antd/es/date-picker/locale/en_US";
import localeTh from "antd/es/date-picker/locale/th_TH";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import styles from "./Input.module.css";

const FormTimePicker = ({
    label = "",
    name = "",
    value = null,
    placeholder = null,
    size = "middle",
    defaultValue = null,
    onChange = () => { },
    required = false,
    vertical = true,
    disabled = false,
    format = "HH:mm",
    labelFontSize = "16px",
    fontWeight = "",
    style = {},
    rules = null,
    minuteStep = 1,
    showNow = true,
    allowClear = false
}) => {
    const { i18n } = useTranslation();

    const layout = {
        labelCol: { span: 24 },
        wrapperCol: { span: 24 }
    };

    const localeFn = () => {
        return i18n.language === "en" ? localeEn : localeTh;
    };

    return (
        <ConfigProvider
            theme={{
                components: {
                    Form: {
                        labelFontSize: labelFontSize,
                    },
                },
            }}
        >
            <Form.Item style={{ padding: "0px", margin: "0px !important" }} shouldUpdate={() => false}>
                {(form) => (
                    <Form.Item
                        {...(vertical && layout)}
                        className={styles.datePicker}
                        labelAlign="left"
                        label={label}
                        name={name}
                        required={required}
                        style={{
                            fontWeight: fontWeight,
                            padding: "0px",
                            margin: "0px !important"
                        }}
                        rules={(rules || []).concat({
                            required,
                            message: `${i18n.language === 'th' ? 'กรุณาระบุ' : 'is required'} ${label}`
                        })}
                    >
                        <TimePicker
                            style={{
                                width: "100%",
                                ...style
                            }}
                            className={styles.datePicker}
                            id={name}
                            name={name}
                            placeholder={placeholder ?? label}
                            defaultValue={defaultValue}
                            format={format}
                            disabled={disabled}
                            size={size}
                            locale={localeFn()}
                            allowClear={allowClear}
                            getPopupContainer={(trigger) => trigger.parentNode}
                            onChange={(time, timeString) => {
                                onChange(time, timeString);
                            }}
                            minuteStep={minuteStep}
                            showNow={showNow}
                            needConfirm={false}
                        />
                    </Form.Item>
                )}
            </Form.Item>
        </ConfigProvider>
    );
};

export default FormTimePicker;